{
  "memberStatus": {
    "ACTIVE": "نشط",
    "BLOCKED": "موقوف"
  },
  "ruleStatus": {
    "ACTIVE": "سارية",
    "SCHEDULED": "مجدولة",
    "ENDED": "منتهية",
    "OFF": "معطّلة"
  },
  "entryKind": {
    "EARN": "مكتسبة من بيع",
    "EARN_REVERSAL": "مستردة بسبب مرتجع",
    "REDEEM": "مستبدلة",
    "REDEEM_RELEASE": "مُعادة إلى الرصيد",
    "BONUS": "مكافأة الترحيب",
    "ADJUST": "تعديل يدوي",
    "EXPIRE": "منتهية الصلاحية",
    "EXPIRE_REVERSAL": "إلغاء انتهاء الصلاحية"
  },
  "overview": {
    "title": "نقاط الولاء",
    "intro": "نقاط يكسبها الأعضاء على مشترياتهم ويستبدلونها في نقطة البيع.",
    "links": {
      "members": "الأعضاء",
      "transactions": "حركات النقاط",
      "program": "البرنامج"
    },
    "off": {
      "title": "البرنامج متوقف",
      "body": "لا يكسب أحد النقاط ولا يستبدلها ما دام البرنامج متوقفًا. تبقى الأرصدة محفوظة ويمكن تعديلها يدويًا.",
      "open": "فتح البرنامج"
    },
    "figures": {
      "label": "أرقام برنامج الولاء",
      "outstanding": "النقاط القابلة للصرف",
      "worth": "قيمتها {{value}}",
      "members": "الأعضاء",
      "active": "النشطون: {{n}}",
      "pending": "النقاط المعلّقة",
      "pendingDetail": "تصبح قابلة للصرف بانتهاء مهلة الإرجاع",
      "expiring": "تنتهي خلال 30 يومًا",
      "expiringDetail": "تنتهي النقاط الأقدم أولًا",
      "owed": "نقاط مستحقة للشركة",
      "owedDetail": "أرصدة دون الصفر بعد المرتجعات"
    },
    "period": {
      "title": "خلال الفترة",
      "issued": "الممنوحة",
      "redeemed": "المستبدلة",
      "expired": "المنتهية",
      "reversed": "المستردة",
      "redemptions": "مبيعات دُفعت بالنقاط",
      "newMembers": "أعضاء جدد"
    },
    "chart": {
      "title": "النقاط الممنوحة والمستبدلة يوميًا",
      "label": "النقاط الممنوحة والمستبدلة في كل يوم من {{from}} إلى {{to}}",
      "issued": "الممنوحة",
      "redeemed": "المستبدلة",
      "day": "اليوم",
      "max": "الأعلى: {{n}}",
      "point": "{{date}}: ممنوحة {{issued}}، مستبدلة {{redeemed}}",
      "empty": "لم تُمنح أي نقاط ولم تُستبدل خلال الفترة."
    },
    "tiers": {
      "title": "الأعضاء حسب المستوى",
      "none": "بلا مستوى",
      "empty": "لا يوجد أعضاء بعد."
    },
    "top": {
      "title": "أكثر الأعضاء كسبًا خلال الفترة",
      "empty": "لم يكسب أحد نقاطًا خلال الفترة."
    }
  },
  "members": {
    "title": "الأعضاء",
    "subtitle": "العملاء المسجلون في برنامج الولاء ونقاطهم.",
    "enrol": "تسجيل عميل",
    "searchPlaceholder": "ابحث بالاسم أو الرمز أو الهاتف…",
    "searchLabel": "البحث في الأعضاء",
    "clearSearch": "مسح البحث",
    "clearFilters": "مسح عوامل التصفية",
    "pendingSmall": "معلّقة",
    "fields": {
      "customer": "العميل",
      "phone": "الهاتف",
      "tier": "المستوى",
      "available": "المتاحة",
      "earned": "المكتسبة",
      "redeemed": "المستبدلة",
      "lastActivity": "آخر نشاط",
      "enrolledAt": "تاريخ الانضمام",
      "status": "الحالة"
    },
    "filters": {
      "status": "الحالة",
      "allStatuses": "كل الحالات",
      "balance": "الرصيد",
      "anyBalance": "أي رصيد",
      "tier": "المستوى",
      "allTiers": "كل المستويات"
    },
    "balance": {
      "positive": "لديه نقاط للصرف",
      "owing": "عليه نقاط",
      "zero": "بلا نقاط"
    },
    "empty": {
      "title": "لا يوجد أعضاء بعد",
      "body": "ينضم العملاء عند أول عملية شراء إذا كان التسجيل التلقائي مفعّلًا، ويمكنك تسجيلهم من هنا.",
      "filteredTitle": "لا يوجد أعضاء مطابقون",
      "filteredBody": "جرّب بحثًا آخر أو امسح عوامل التصفية."
    }
  },
  "enrol": {
    "title": "تسجيل عميل",
    "body": "ينضم العميل إلى البرنامج الآن ويبدأ الكسب من عملية الشراء التالية.",
    "customer": "العميل",
    "customerHint": "لا يمكن تسجيل العميل النقدي.",
    "chooseCustomer": "اختر العميل المراد تسجيله",
    "confirm": "تسجيل",
    "openMember": "فتح صفحة العضو",
    "toast": "انضم {{name}} إلى البرنامج"
  },
  "member": {
    "since": "عضو منذ {{date}}",
    "lastActivity": "آخر نشاط {{date}}",
    "openCustomer": "صفحة العميل",
    "blockedOn": "أُوقف في {{date}}",
    "blockedBody": "العضو الموقوف لا يكسب النقاط ولا يستبدلها، ويبقى رصيده محفوظًا.",
    "blockedReason": "السبب: {{reason}}",
    "figures": "النقاط",
    "available": "المتاحة",
    "owes": "عليه نقاط مستحقة",
    "pending": "المعلّقة",
    "pendingDetail": "تصبح قابلة للصرف بعد مهلة الإرجاع",
    "expiringSoon": "تنتهي قريبًا",
    "expiringSoonDetail": "خلال 30 يومًا",
    "earned": "المكتسبة",
    "redeemed": "المستبدلة",
    "expired": "المنتهية",
    "details": "العضوية",
    "statement": "كشف النقاط",
    "statementEmpty": "لم تتحرك أي نقاط بعد.",
    "actions": {
      "adjust": "تعديل النقاط",
      "block": "إيقاف",
      "unblock": "إلغاء الإيقاف"
    },
    "fields": {
      "customerCode": "رمز العميل",
      "enrolledAt": "تاريخ الانضمام",
      "lastActivity": "آخر نشاط",
      "blockedReason": "سبب الإيقاف"
    },
    "tier": {
      "title": "المستوى",
      "qualifying": "المكتسبة خلال آخر 12 شهرًا",
      "current": "المستوى الحالي: {{tier}}",
      "noneYet": "لم يبلغ أي مستوى بعد.",
      "progress": "التقدم نحو المستوى التالي",
      "toNext_zero": "لم يتبقَّ شيء لبلوغ مستوى {{tier}}",
      "toNext_one": "تبقّت نقطة واحدة لبلوغ مستوى {{tier}}",
      "toNext_two": "تبقّت نقطتان لبلوغ مستوى {{tier}}",
      "toNext_few": "تبقّت {{n}} نقاط لبلوغ مستوى {{tier}}",
      "toNext_many": "تبقّت {{n}} نقطة لبلوغ مستوى {{tier}}",
      "toNext_other": "تبقّت {{n}} نقطة لبلوغ مستوى {{tier}}",
      "top": "أعلى مستوى.",
      "window": "تُحتسب المستويات بالنقاط المكتسبة من المشتريات خلال آخر 12 شهرًا."
    }
  },
  "adjust": {
    "title": "تعديل النقاط",
    "body": "النقاط التي يمكن لـ {{name}} صرفها الآن: {{n}}",
    "direction": "إضافة أو خصم",
    "add": "إضافة نقاط",
    "deduct": "خصم نقاط",
    "points": "النقاط",
    "reason": "السبب",
    "reasonHint": "يُحفظ في كشف النقاط وفي سجل التدقيق.",
    "expiresOn": "تنتهي في",
    "expiresOnHint": "اتركه فارغًا لتتبع مدة صلاحية البرنامج.",
    "confirmAdd": "إضافة النقاط",
    "confirmDeduct": "خصم النقاط",
    "toastAdded_zero": "لم تُضف أي نقطة إلى رصيد {{name}}",
    "toastAdded_one": "أُضيفت نقطة واحدة إلى رصيد {{name}}",
    "toastAdded_two": "أُضيفت نقطتان إلى رصيد {{name}}",
    "toastAdded_few": "أُضيفت {{n}} نقاط إلى رصيد {{name}}",
    "toastAdded_many": "أُضيفت {{n}} نقطة إلى رصيد {{name}}",
    "toastAdded_other": "أُضيفت {{n}} نقطة إلى رصيد {{name}}",
    "toastDeducted_zero": "لم تُخصم أي نقطة من رصيد {{name}}",
    "toastDeducted_one": "خُصمت نقطة واحدة من رصيد {{name}}",
    "toastDeducted_two": "خُصمت نقطتان من رصيد {{name}}",
    "toastDeducted_few": "خُصمت {{n}} نقاط من رصيد {{name}}",
    "toastDeducted_many": "خُصمت {{n}} نقطة من رصيد {{name}}",
    "toastDeducted_other": "خُصمت {{n}} نقطة من رصيد {{name}}"
  },
  "block": {
    "title": "إيقاف {{name}}؟",
    "body": "يتوقف عن كسب النقاط واستبدالها حتى يُلغى الإيقاف، ويبقى رصيده محفوظًا.",
    "reason": "السبب",
    "confirm": "إيقاف العضو",
    "toast": "أُوقف {{name}}"
  },
  "unblock": {
    "title": "إلغاء إيقاف {{name}}؟",
    "body": "يعود إلى كسب النقاط واستبدالها اعتبارًا من الآن.",
    "confirm": "إلغاء إيقاف العضو",
    "toast": "عاد {{name}} نشطًا"
  },
  "entries": {
    "kindFilter": "النوع",
    "allKinds": "كل الأنواع",
    "draft": "مسودة",
    "system": "النظام",
    "availableOn": "متاحة في {{date}}",
    "expiresOn": "تنتهي في {{date}}",
    "fields": {
      "date": "التاريخ",
      "member": "العضو",
      "kind": "النوع",
      "points": "النقاط",
      "value": "القيمة",
      "document": "المستند",
      "dates": "الإتاحة / الانتهاء",
      "reason": "السبب",
      "by": "بواسطة"
    },
    "empty": {
      "filteredTitle": "لا توجد نتائج مطابقة",
      "filteredBody": "جرّب بحثًا آخر أو امسح عوامل التصفية."
    }
  },
  "transactions": {
    "title": "حركات النقاط",
    "subtitle": "كل حركة على النقاط: المكتسبة والمستبدلة والمستردة والمُعادة والمعدّلة والمنتهية.",
    "searchPlaceholder": "ابحث برقم الفاتورة أو الإشعار الدائن أو السبب أو العميل…",
    "searchLabel": "البحث في حركات النقاط",
    "empty": {
      "title": "لم تتحرك أي نقاط بعد",
      "body": "يكسب الأعضاء النقاط عند ترحيل فواتير مبيعاتهم أو سدادها."
    }
  },
  "program": {
    "title": "برنامج الولاء",
    "subtitle": "كيف يكسب الأعضاء النقاط ويستبدلونها. لم يُحفظ بعد: هذه هي الشروط المبدئية.",
    "lastChanged": "آخر تعديل في {{date}}",
    "lastChangedBy": "آخر تعديل في {{date}} بواسطة {{name}}",
    "readOnlyTitle": "للقراءة فقط",
    "readOnlyBody": "تعديل البرنامج يتطلب صلاحية إدارة برنامج الولاء.",
    "loadFailed": "تعذّر تحميل البرنامج",
    "notSaved": "لم يُحفظ البرنامج",
    "save": "حفظ البرنامج",
    "discard": "تجاهل التغييرات",
    "saveHint": "{{shortcut}} للحفظ",
    "activeOn": "مفعّل: يكسب الأعضاء النقاط ويستبدلونها",
    "activeOff": "متوقف: لا كسب ولا استبدال",
    "autoEnrollLabel": "تسجيل العملاء عند أول عملية شراء",
    "earnIncludesTaxLabel": "الكسب على ضريبة القيمة المضافة أيضًا",
    "combineLabel": "السماح بالنقاط على المبيعات التي عليها خصم",
    "toast": {
      "saved": "حُفظ البرنامج"
    },
    "conflict": {
      "title": "عدّل شخص آخر البرنامج",
      "body": "أعد التحميل لترى تعديلاته، ثم أجرِ تعديلاتك من جديد.",
      "reload": "إعادة التحميل"
    },
    "sections": {
      "program": "البرنامج",
      "earning": "الكسب",
      "earningHint": "تُضاف النقاط على فواتير المبيعات المرحّلة.",
      "redeeming": "الاستبدال",
      "redeemingHint": "يصرف الأعضاء نقاطهم في نقطة البيع خصمًا قبل ضريبة القيمة المضافة."
    },
    "fields": {
      "active": "الحالة",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "autoEnroll": "التسجيل التلقائي",
      "welcomePoints": "نقاط الترحيب",
      "earnRate": "النقاط لكل 1.000 ر.ع.",
      "earnOn": "إضافة النقاط",
      "earnIncludesTax": "ضريبة القيمة المضافة",
      "rounding": "التقريب",
      "availableAfterDays": "قابلة للصرف بعد",
      "expiryMonths": "تنتهي بعد",
      "redeemRate": "سعر الاستبدال",
      "minRedeemPoints": "أقل عدد نقاط للاستبدال",
      "maxRedeemPercent": "أقصى ما يُدفع بالنقاط من البيع",
      "minRedeemSale": "أقل قيمة بيع للاستبدال",
      "combineWithDiscounts": "خصومات البيع"
    },
    "hints": {
      "active": "الإيقاف يحفظ كل الأرصدة، ولا يكسب أحد ولا يستبدل حتى يُعاد التفعيل.",
      "autoEnroll": "عند الإيقاف: يكسب النقاط فقط العملاء المسجلون يدويًا.",
      "welcomePoints": "تُمنح مرة واحدة عند انضمام العميل. الصفر يعني لا شيء.",
      "earnRate": "على المبلغ بعد الخصومات وقبل الضريبة ما لم تُشمل الضريبة. الصفر يوقف الكسب.",
      "rounding": "يُطبق مرة واحدة لكل فاتورة.",
      "availableAfterDays": "مهلة للإرجاع: الصفر يجعل النقاط قابلة للصرف فورًا.",
      "expiryMonths": "تُحسب من تاريخ إتاحة النقاط للصرف. الصفر: لا تنتهي أبدًا.",
      "minRedeemPoints": "يجب أن يملك العضو هذا العدد على الأقل ليستبدل.",
      "maxRedeemPercent": "من قيمة البيع بعد الخصومات وقبل الضريبة.",
      "minRedeemSale": "بعد الخصومات وقبل الضريبة.",
      "combineWithDiscounts": "عند الإيقاف: لا يمكن استبدال النقاط في عملية بيع عليها خصم على كامل البيع."
    },
    "units": {
      "points": "نقطة",
      "days": "يوم",
      "months": "شهر"
    },
    "earnOn": {
      "POSTED": "عند ترحيل الفاتورة",
      "POSTEDHint": "يرى الأعضاء نقاطهم فور إصدار فاتورة البيع.",
      "PAID": "عند سدادها بالكامل",
      "PAIDHint": "المبيعات الآجلة لا تُكسب نقاطها إلا بعد سداد العميل."
    },
    "rounding": {
      "FLOOR": "التقريب لأسفل",
      "NEAREST": "التقريب لأقرب نقطة",
      "CEIL": "التقريب لأعلى"
    },
    "redeemRateOption_zero": "{{n}} نقطة = {{value}}",
    "redeemRateOption_one": "نقطة واحدة = {{value}}",
    "redeemRateOption_two": "نقطتان = {{value}} · النقطة الواحدة = {{point}}",
    "redeemRateOption_few": "{{n}} نقاط = {{value}} · النقطة الواحدة = {{point}}",
    "redeemRateOption_many": "{{n}} نقطة = {{value}} · النقطة الواحدة = {{point}}",
    "redeemRateOption_other": "{{n}} نقطة = {{value}} · النقطة الواحدة = {{point}}",
    "example": {
      "title": "مثال تطبيقي",
      "earn_zero": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة لا تكسب أي نقطة.",
      "earn_one": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة تكسب نقطة واحدة.",
      "earn_two": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة تكسب نقطتين.",
      "earn_few": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة تكسب {{n}} نقاط.",
      "earn_many": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة تكسب {{n}} نقطة.",
      "earn_other": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة تكسب {{n}} نقطة.",
      "earnWithTax_zero": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة ({{gross}} شاملة ضريبة 5%) لا تكسب أي نقطة.",
      "earnWithTax_one": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة ({{gross}} شاملة ضريبة 5%) تكسب نقطة واحدة.",
      "earnWithTax_two": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة ({{gross}} شاملة ضريبة 5%) تكسب نقطتين.",
      "earnWithTax_few": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة ({{gross}} شاملة ضريبة 5%) تكسب {{n}} نقاط.",
      "earnWithTax_many": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة ({{gross}} شاملة ضريبة 5%) تكسب {{n}} نقطة.",
      "earnWithTax_other": "عملية بيع بقيمة {{net}} قبل ضريبة القيمة المضافة ({{gross}} شاملة ضريبة 5%) تكسب {{n}} نقطة.",
      "redeem": "{{n}} نقطة تخصم {{value}} من عملية البيع (النقطة الواحدة = {{point}}).",
      "incomplete": "أدخل معدل الكسب وسعر الاستبدال لترى مثالًا."
    }
  },
  "tiers": {
    "title": "المستويات",
    "hint": "تُبلغ بالنقاط المكتسبة من المشتريات خلال آخر 12 شهرًا، ويضاعف كل مستوى ما يكسبه أعضاؤه.",
    "add": "إضافة مستوى",
    "edit": "تعديل",
    "delete": "حذف",
    "actionsFor": "إجراءات {{name}}",
    "newTitle": "مستوى جديد",
    "editTitle": "تعديل {{name}}",
    "dialogBody": "ينتقل الأعضاء إلى المستوى بمجرد أن تبلغه نقاطهم خلال آخر 12 شهرًا.",
    "save": "حفظ المستوى",
    "deleteTitle": "حذف {{name}}؟",
    "deleteBody": "ينتقل أعضاؤه إلى المستوى الأدنى، أو يصبحون بلا مستوى.",
    "deleteConfirm": "حذف المستوى",
    "fields": {
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "minPoints": "النقاط المطلوبة",
      "multiplier": "مضاعف الكسب",
      "members": "الأعضاء"
    },
    "hints": {
      "minPoints": "المكتسبة من المشتريات خلال آخر 12 شهرًا.",
      "multiplier": "من 1 إلى 10: القيمة 1.5 تعني الكسب مرة ونصفًا."
    },
    "empty": {
      "title": "لا توجد مستويات",
      "body": "بدون مستويات يكسب كل الأعضاء بمعدل البرنامج."
    },
    "toast": {
      "created": "أُضيف {{name}}",
      "updated": "حُفظ {{name}}",
      "deleted": "حُذف {{name}}"
    }
  },
  "rules": {
    "title": "قواعد المكافآت",
    "hint": "كسب أكثر، أو عدد ثابت من النقاط، أو لا شيء على بعض الأصناف، دائمًا أو بين تاريخين فقط. تُطبق القاعدة الأكثر تحديدًا.",
    "add": "إضافة قاعدة",
    "edit": "تعديل",
    "delete": "حذف",
    "actionsFor": "إجراءات {{name}}",
    "newTitle": "قاعدة مكافأة جديدة",
    "editTitle": "تعديل {{name}}",
    "dialogBody": "قاعدة النوع الفرعي تتقدم على قاعدة منتجه، وقاعدة المنتج تتقدم على قاعدة فئته، وقاعدة الفئة تتقدم على القاعدة العامة.",
    "namePlaceholder": "مثال: نقاط مضاعفة على القهوة",
    "save": "حفظ القاعدة",
    "deleteTitle": "حذف {{name}}؟",
    "deleteBody": "تُحتسب المبيعات من الآن دونها، وتبقى النقاط المكتسبة سابقًا.",
    "deleteConfirm": "حذف القاعدة",
    "allHint": "كل صنف يُباع.",
    "noAccess": "اختيار الأصناف يتطلب صلاحية البحث عن المنتجات.",
    "searchCategories": "ابحث في الفئات…",
    "noCategories": "لا توجد فئات",
    "fields": {
      "name": "الاسم",
      "appliesTo": "تنطبق على",
      "earns": "الكسب",
      "mode": "طريقة الكسب",
      "multiplier": "المضاعف",
      "fixedPoints": "النقاط لكل وحدة",
      "dates": "التواريخ",
      "startsOn": "من",
      "endsOn": "إلى",
      "status": "الحالة",
      "active": "القاعدة مفعّلة"
    },
    "hints": {
      "multiplier": "مضروبًا في معدل البرنامج: 2 يضاعف الكسب، و0 يلغيه.",
      "fixedPoints": "لكل وحدة مبيعة، مهما كان السعر.",
      "none": "مبيعات هذه الأصناف لا تكسب نقاطًا.",
      "dates": "اترك التاريخين فارغين لقاعدة دائمة؛ العرض المؤقت يتقدم على القاعدة الدائمة للأصناف نفسها."
    },
    "empty": {
      "title": "لا توجد قواعد مكافآت",
      "body": "كل الأصناف تكسب بمعدل البرنامج (مضروبًا في مضاعف مستوى العضو)."
    },
    "target": {
      "ALL": "كل الأصناف",
      "CATEGORY": "فئة",
      "PRODUCT": "منتج",
      "VARIANT": "نوع فرعي"
    },
    "targetNamed": {
      "ALL": "كل الأصناف",
      "CATEGORY": "الفئة: {{name}}",
      "PRODUCT": "المنتج: {{name}}",
      "VARIANT": "النوع الفرعي: {{name}}"
    },
    "pick": {
      "ALL": "الأصناف",
      "CATEGORY": "الفئة",
      "PRODUCT": "المنتج",
      "VARIANT": "النوع الفرعي"
    },
    "pickPlaceholder": {
      "ALL": "كل الأصناف",
      "CATEGORY": "اختر فئة",
      "PRODUCT": "ابحث عن منتج",
      "VARIANT": "ابحث عن نوع فرعي بالاسم أو رمز المنتج أو الباركود"
    },
    "mode": {
      "MULTIPLIER": "مضاعفة المعدل",
      "FIXED": "نقاط ثابتة لكل وحدة",
      "NONE": "بلا نقاط"
    },
    "modeText": {
      "MULTIPLIER": "× {{multiplier}}",
      "FIXED_zero": "لا نقاط لكل وحدة",
      "FIXED_one": "نقطة واحدة لكل وحدة",
      "FIXED_two": "نقطتان لكل وحدة",
      "FIXED_few": "{{n}} نقاط لكل وحدة",
      "FIXED_many": "{{n}} نقطة لكل وحدة",
      "FIXED_other": "{{n}} نقطة لكل وحدة",
      "NONE": "بلا نقاط"
    },
    "dates": {
      "always": "دائمًا",
      "between": "{{from}} – {{to}}",
      "from": "من {{from}}",
      "until": "حتى {{to}}",
      "noStart": "بلا بداية",
      "noEnd": "بلا نهاية"
    },
    "toast": {
      "created": "أُضيفت {{name}}",
      "updated": "حُفظت {{name}}",
      "deleted": "حُذفت {{name}}"
    }
  },
  "customerTab": {
    "title": "الولاء",
    "notMember": "ليس عضوًا بعد",
    "notMemberBody": "سجّل العميل ليكسب النقاط على مشترياته.",
    "autoEnrolBody": "ينضم عند أول عملية شراء، أو يمكنك تسجيله الآن.",
    "enrol": "تسجيل",
    "openMember": "فتح صفحة العضو"
  },
  "leave": {
    "title": "المغادرة دون حفظ؟",
    "body": "ستفقد تعديلاتك على البرنامج.",
    "confirm": "مغادرة",
    "cancel": "البقاء"
  },
  "errors": {
    "LOYALTY_NOT_ELIGIBLE": "لا يمكن لهذا العميل الانضمام إلى البرنامج: العميل النقدي لا يكسب نقاطًا، والعميل المؤرشف يجب استعادته أولًا.",
    "LOYALTY_ALREADY_MEMBER": "هذا العميل عضو في البرنامج بالفعل.",
    "LOYALTY_INSUFFICIENT_POINTS": "سيصبح رصيد العضو دون الصفر: اخصم عددًا أقل.",
    "insufficientCount_zero": "لا توجد لدى العضو نقاط قابلة للصرف: اخصم عددًا أقل.",
    "insufficientCount_one": "لدى العضو نقطة واحدة فقط قابلة للصرف: اخصم عددًا أقل.",
    "insufficientCount_two": "لدى العضو نقطتان فقط قابلتان للصرف: اخصم عددًا أقل.",
    "insufficientCount_few": "لدى العضو {{n}} نقاط فقط قابلة للصرف: اخصم عددًا أقل.",
    "insufficientCount_many": "لدى العضو {{n}} نقطة فقط قابلة للصرف: اخصم عددًا أقل.",
    "insufficientCount_other": "لدى العضو {{n}} نقطة فقط قابلة للصرف: اخصم عددًا أقل.",
    "LOYALTY_TIER_DUPLICATE": "يوجد مستوى آخر بهذا الاسم أو بهذا العدد من النقاط."
  },
  "validation": {
    "wholeNumber": "أدخل عددًا صحيحًا",
    "twoDecimals": "أدخل رقمًا بمنزلتين عشريتين على الأكثر",
    "earnRateRange": "أدخل من 0 إلى 1000 نقطة",
    "nameProgram": "أدخل اسم البرنامج",
    "listedRate": "اختر أحد الأسعار المدرجة",
    "percentRange": "أدخل نسبة من 0 إلى 100",
    "nameTier": "أدخل اسم المستوى",
    "atLeastOnePoint": "أدخل نقطة واحدة على الأقل",
    "multiplierRange": "أدخل قيمة من 1 إلى 10",
    "nameRule": "أدخل اسم القاعدة",
    "ruleMultiplierRange": "أدخل قيمة من 0 إلى 100",
    "allNoItem": "القاعدة العامة لا تحدد صنفًا",
    "chooseTarget": "اختر ما تنطبق عليه القاعدة",
    "enterMultiplier": "أدخل المضاعف",
    "enterFixedPoints": "أدخل النقاط لكل وحدة",
    "endBeforeStart": "تاريخ النهاية قبل تاريخ البداية",
    "enterPoints": "أدخل النقاط المراد إضافتها أو خصمها",
    "onlyAddedExpire": "لا تنتهي صلاحية إلا النقاط المضافة"
  }
}
